module.exports = __webpack_public_path__ + "img/Uzbekistan.9ad7705d.png";